import { render, staticRenderFns } from "./NewAnnotation.vue?vue&type=template&id=120f09d6&scoped=true&"
import script from "./NewAnnotation.vue?vue&type=script&lang=js&"
export * from "./NewAnnotation.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/new_annotation.scss?vue&type=style&index=0&id=120f09d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120f09d6",
  null
  
)

export default component.exports